import { statusOptions } from '../config/AccountantFormFields';

const legacyStatusByNewStatus = statusOptions.reduce(
  (a, { value, newStatus }) => ({ ...a, [newStatus]: value }),
  {},
);

// Self assessments with an assignee are on the new Bookkeeper Portal flow, so
// their status is mapped back to the legacy status it was set from. Those
// without one are legacy self assessments and keep their status as is.
const getLegacyStatus = (selfAssessment) => {
  const { status, assignee } = selfAssessment || {};

  if (!assignee) return status;

  return legacyStatusByNewStatus[status] || status;
};

export default getLegacyStatus;
